import { APARTMENT_FEATURES, IMAGES } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const ApartmentHighlights = () => (
  <section data-testid="apartment-highlights-section" className="py-20 sm:py-28 bg-[#F4FAE8]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <SectionHeading index="02" eyebrow="Living Spaces" title="Homes shaped by light, air and openness" />
          <Reveal delay={0.2}>
            <div className="img-frame rounded-sm overflow-hidden mt-10 hidden lg:block">
              <div className="overflow-hidden rounded-sm">
                <img src={IMAGES.living} alt="Bright premium apartment living room with balcony view at Vinayak 21 Acres" className="w-full h-[420px] object-cover" loading="lazy" />
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7 space-y-4">
          {APARTMENT_FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={0.07 * i}>
              <div
                data-testid={`apartment-feature-${i}`}
                className="group bg-[#FFFFFF] border border-[#DCECC0] rounded-xl p-6 sm:p-7 flex gap-6 items-start hover:border-[#84CC16] hover:shadow-[0_16px_36px_-18px_rgba(77,124,15,0.2)] transition-all duration-500"
              >
                <span className="font-mono-spec text-[#84CC16] text-sm pt-1 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h3 className="font-serif-display text-xl sm:text-2xl font-medium text-[#365314] leading-snug">{f.title}</h3>
                  <p className="text-sm text-[#65A30D] mt-2 leading-relaxed">{f.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
